import getShorterText from "Common/componentUtils/getShorterText";
import { themeVariables } from "Components/theme";
import edgeSvg from "Content/images/graph/edge.svg";
import toString from "lodash/toString";
import React, { useMemo } from "react";
const mainDataContainerStyle = {
    display: "grid",
    alignContent: "center"
};
const displayNameStyle = {
    paddingTop: 2,
    paddingBottom: 3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    lineHeight: themeVariables["line-height-medium"]
};
const fromToDescriptionStyle = {
    fontSize: themeVariables["font-size-small"],
    color: themeVariables["text-muted"],
    overflow: "hidden",
    textOverflow: "ellipsis",
    lineHeight: themeVariables["line-height-medium"]
};
const imgStyle = {
    borderRadius: "50%",
    objectFit: "cover",
    border: "0"
};
export default function EdgeLabel(props) {
    const labelRootStyle = useMemo(() => ({
        ...(props.style || {}),
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        gridTemplateRows: "1fr",
        boxSizing: "border-box"
    }), [props.style]);
    const imageContainerStyle = useMemo(() => props.imgSize
        ? {
            width: props.imgSize,
            height: props.imgSize,
            minHeight: props.imgSize,
            minWidth: props.imgSize,
            marginRight: 10,
            borderRadius: "50%",
            backgroundColor: themeVariables["gray-100"],
            display: "grid",
            alignContent: "center",
            justifyContent: "center"
        }
        : undefined, [props.imgSize]);
    if (!props.data)
        return null;
    const displayName = props.data.MethodName;
    return (React.createElement("div", { className: props.className, style: labelRootStyle },
        Boolean(props.imgSize) && (React.createElement("div", { style: imageContainerStyle },
            React.createElement("img", { src: edgeSvg, width: props.imgSize, height: props.imgSize, title: "", alt: "", style: imgStyle }))),
        !props.onlyIcon && (React.createElement("div", { style: mainDataContainerStyle },
            displayName && (React.createElement("div", { style: displayNameStyle, title: toString(displayName) }, getShorterText(displayName, props.titleMaxLength))),
            props.data.FromNodeName && props.data.ToNodeName && (React.createElement("div", { style: fromToDescriptionStyle },
                React.createElement("span", null, props.data.FromNodeName),
                React.createElement("i", { className: "d-inline-block ml-0_5 mr-0_5 icon-arrow-down rotate-270" }),
                React.createElement("span", null, props.data.ToNodeName)))))));
}
EdgeLabel.defaultProps = {
    imgSize: 50,
    titleMaxLength: 100
};
